// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"600":"26a63e6c","787":"8ec0d732"}[chunkId] + ".chunk.js";
};